export const patentDraftQueryKeys = {
  getAllPatentDrafts: 'getAllPatentDrafts',
  getPatentDraftById: 'getPatentDraftById',
  getPatentDraftDocx: 'getPatentDraftDocx',
  getPatentDraftFiles: 'getPatentDraftFiles',
  uploadPatentDraftFile: 'uploadPatentDraftFile',
  deletePatentDraftFile: 'deletePatentDraftFile',
  getPatentDraftFileById: 'getPatentDraftFileById',
  getChatMessages: 'getChatMessages',
  getChatMessageById: 'getChatMessageById',
  getReferenceSignsByPatentDraft: 'getReferenceSignsByPatentDraft',
  getPatentDraftChecks: 'getPatentDraftChecks',
  getGlossarySearchTermDefinitions: 'getGlossarySearchTermDefinitions',
  getGlossarySearchRelatedTerms: 'getGlossarySearchRelatedTerms',
  getChanges: 'getChanges',
  getCompoundThumbnail: 'getCompoundThumbnail',
  getJurisdictionLanguages: 'getJurisdictionLanguages',
  getComments: 'getComments',
  getCommentById: 'getCommentById',
  getTemplates: 'getTemplates',
  getTemplateById: 'getTemplateById',
  getDefaultTemplate: 'getDefaultTemplate',

  getReferenceSignsByFigure: 'getReferenceSignsByFigure',
  getTemporaryFile: 'getTemporaryFile',

  getNoveltyAnalyses: 'getNoveltyAnalyses',
  getNoveltyAnalysisProgressStatus: 'getNoveltyAnalysisProgressStatus',
  getNoveltyAnalysisResults: 'getNoveltyAnalysisResults',
  getNoveltyAnalysis: 'getNoveltyAnalysis',
  getNoveltyAnalysisStatus: 'getNoveltyAnalysisStatus',
  getNoveltyFeatures: 'getNoveltyFeatures',
};
